/**
 * Pure helpers for the Migration page (ADR 0055): which action a batch
 * offers next, and the one-line progress summary of its phones.
 */

import type { MigrationBatchStatus, MigrationItemState } from "@pbxmgr/api";

/** The phone states in the order they are walked, for the progress line. */
export const ITEM_ORDER: MigrationItemState[] = [
  "planned",
  "held",
  "pointed",
  "point_failed",
  "pushed",
  "push_failed",
  "arrived",
  "registered",
  "rolling_back",
  "rolled_back",
];

/** Which operator actions a batch in this status offers. */
export function actionsFor(status: MigrationBatchStatus): {
  point: boolean;
  push: boolean;
  rollback: boolean;
  cancel: boolean;
} {
  return {
    point: status === "draft",
    push: status === "pointed" || status === "failed",
    rollback: status === "pointed" || status === "failed",
    cancel: status === "draft",
  };
}

/** `3 registered · 1 arrived · 2 held` — states with no phones are left out. */
export function progressLine(counts: Partial<Record<MigrationItemState, number>>): string {
  const parts = ITEM_ORDER.filter((s) => (counts[s] ?? 0) > 0).map(
    (s) => `${counts[s]} ${s.replace("_", " ")}`,
  );
  return parts.length === 0 ? "no phones" : parts.join(" · ");
}

/** A protected step is armed only when the operator typed the batch's name. */
export function nameConfirmed(typed: string, name: string): boolean {
  return typed.trim() !== "" && typed.trim() === name.trim();
}
